import Cell from "@/classes/Cell";
import CellCollection from '@/classes/CellCollection';
import {shuffle} from "lodash";

type Direction = 'up' | 'down' | 'left' | 'right';
type Neighbor = {
    cell: Cell;
    direction: Direction;
}

interface GameOptions {
    width?: number;
    cells?: number[];
}

export default class Game {
    cells: Cell[] = [];
    width = 1;

    constructor({width = 1, cells = []}: GameOptions = {}) {
        this.width = width;
        cells?.forEach(cell => this.addCell(new Cell(cell)));
    }

    addCell(cell: Cell) {
        this.cells.push(cell);
    }

    addRandomCells(num_cells: number) {
        if (num_cells % 2) {
            throw new Error('can only add an even number of cells');
        }

        const values = [];
        let value;
        for (let i = 0; i < num_cells / 2; i++) {
            value = Math.ceil(Math.random() * 9);
            values.push(value);
            values.push((Math.random() > .5) ? value : 10 - value);
        }

        shuffle(values).forEach(value => this.addCell(new Cell(value)))
    }

    get display_cells(): Cell[] {
        return this.cells;
    }

    getNeighbors(cell: Cell):
        Neighbor[] {
        if (cell.is_solved) {
            return [];
        }

        return ['up', 'down', 'left', 'right'].reduce((carry: Neighbor[], dir: string): Neighbor[] => {
            const value = this.getNeighbor(cell, dir as Direction);
            if (value) {
                carry.push({direction: dir as Direction, cell: value});
            }

            return carry;
        }, [])
    }

    getNeighbor(cell: Cell, direction: Direction): Cell | undefined {
        let index = this.cells.indexOf(cell);
        let step = (direction === "up" || direction === "down") ? this.width : 1;

        if (direction === "up" || direction === "left") {
            step *= -1;
        }

        while (this.cells[index += step]?.is_solved) ;

        return this.cells[index];
    }

    matchPair(cell1: Cell, cell2: Cell): boolean {
        if ((cell1.value !== cell2.value) && (cell1.value + cell2.value !== 10)) {
            return false;
        }

        cell1.is_solved = true;
        cell2.is_solved = true;

        //
        // const cell1_index = Math.floor(this.cells.indexOf(cell1) / this.width);
        // const cell2_index = Math.floor(this.cells.indexOf(cell2) / this.width);
        // // We're in the same row
        // if (cell1_index === cell2_index) {
        //     let counter = 0;
        //     let true_index;
        //     for (let i = 0; i < this.width; i++) {
        //         true_index = i + (this.width * cell1_index);
        //
        //         if (this.cells[true_index]?.is_solved) {
        //             counter++;
        //         }
        //     }
        //     if (counter === this.width) {
        //         const empties = this.cells.splice(this.width * cell1_index, this.width);
        //         this.cells = this.cells.concat(empties);
        //     }
        //
        // }


        return true;
    }

    shuffle() {
        this.cells = shuffle(this.cells);
    }

    removeEmpties() {
        this.cells = this.cells.filter(cell => !cell.is_solved);
    }

    adjustWidth(): void {
        this.width = Math.ceil(Math.sqrt(this.cells.length));
    }

    getRowFor(cell: Cell): CellCollection {
        const index = this.cells.indexOf(cell);
        const row_index = Math.floor(index / this.width) * this.width;
        const cells = this.cells.slice(row_index, row_index + this.width);
        return new CellCollection(cells);
    }

    getColumnFor(cell: Cell): CellCollection {
        const cells: Cell[] = [];
        const column_index = this.cells.indexOf(cell) % this.width;

        for (let i = column_index; i < this.cells.length; i += this.width) {
            cells.push(this.cells[i]);
        }
        return new CellCollection(cells);
    }

    removeCell(cell: Cell) {
        const index = this.cells.indexOf(cell);
        return this.cells.splice(index, 1);
    }
}